<template>
    <Header>
        <div class="d-flex-item">
            <a class="d-inline line-h-0">
                <img src="static/icon/icon-logo-picture-green@256px.svg" style="height: 36px;" @click="onLogos"/>
            </a>
        </div>
        <div class="d-block">
            <div class="navigation">
                <router-link :id="index" :class="{active : isActive === index}" :to="{path: item.router}" v-for="(item, index) in navigation" :key="index" @click.native="onNavigation(item, index)">{{ language === 'zh-cn' ? item.cnText : item.enText }}</router-link>
            </div>
        </div>
        <div class="d-block">
            <div class="d-flex justify-start">
                <div class="d-inline pl-xl">
                    <Avatar size="small" :src="language === 'zh-cn' ? 'static/icon/icon-language-cn@24px.png' : 'static/icon/icon-language-en@24px.png'"/>
                    <Dropdown placement="bottom-end" trigger="hover">
                        <a class="size-14 c-black">
                            <span class="pl-ns">{{ language === 'zh-cn' ? 'ZH-CN' : 'EN-US' }}</span>
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <DropdownMenu class="width-120" slot="list">
                            <DropdownItem @click.native="__toggleLanguage">
                                <span class="d-flex justify-start">
                                    <img :src="language === 'en-us' ? 'static/icon/icon-language-cn@24px.png' : 'static/icon/icon-language-en@24px.png'"/>
                                    <u class="d-flex-item pl-xs">{{ language === 'en-us' ? 'ZH-CN' : 'EN-US' }}</u>
                                </span>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
        </div>
        <div class="bdsharebuttonbox" data-box="share-box" v-show="shareBox" @mouseleave="toggleShareBox">
            <span class="d-block" data-cmd="more">{{ language === 'zh-cn' ? '分享到' : 'Share To' }}：</span>
            <div class="d-block plr-md bdr-1">
                <Tooltip class="item" content="QQ">
                    <a class="icon">
                        <img data-cmd="sqq" src="static/icon/icon-share-qq.svg"/>
                    </a>
                </Tooltip>
            </div>
            <div class="d-block plr-md bdr-1">
                <Tooltip class="item" content="微信">
                    <a class="icon">
                        <img data-cmd="weixin" src="static/icon/icon-share-wexin.svg"/>
                    </a>
                </Tooltip>
            </div>
            <div class="d-block plr-md bdr-1">
                <Tooltip class="item" content="Facebook">
                    <a class="icon">
                        <img data-cmd="fbook" src="static/icon/icon-share-facebook.svg"/>
                    </a>
                </Tooltip>
            </div>
            <div class="d-block plr-md bdr-1">
                <Tooltip class="item" content="Twitter">
                    <a class="icon">
                        <img data-cmd="twi" src="static/icon/icon-share-twitter.svg"/>
                    </a>
                </Tooltip>
            </div>
        </div>
        <a class="icon-share d-none" @mouseenter="toggleShareBox" @mouseleave="toggleShareBox">
            <Button shape="circle" size="small" :icon="shareBox === true ? 'md-close' : 'md-share'"/>
        </a>
    </Header>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                language: 'zh-cn',
                navigation: [
                    {
                        router: '/',
                        cnText: '首页',
                        enText: 'Home',
                        name: 'index',
                    },
                    {
                        router: '/news',
                        cnText: '新闻/活动',
                        enText: 'News/Events',
                        name: 'news',
                    },
                    {
                        router: '/business',
                        cnText: '业务平台',
                        enText: 'Business',
                        name: 'business',
                    },
                    {
                        router: '/experiment',
                        cnText: '产品与技术',
                        enText: 'Products & Technology',
                        name: 'experiment',
                    },
                    // {
                    //     router: '/invest',
                    //     cnText: '投资我们',
                    //     enText: 'Investment',
                    //     name: 'invest',
                    // },
                    {
                        router: '/about',
                        cnText: '关于我们',
                        enText: 'About',
                        name: 'about',
                    },
                ],
                isActive: 0,
                shareBox: false,
            }
        },
        created() {
            this.navDefaultActive();
        },
        mounted() {
        },
        methods: {
            // 导航默认选中
            navDefaultActive(){
                var _router = localStorage.getItem('navRouter');
                if (_router && _router === ''){
                    for (var i = 0; i < this.navigation.length; i++){
                        if (_router === this.navigation[i].name){
                            this.isActive = i;
                        }
                    }
                } else {
                    this.isActive = 0;
                    this.$emit('actions', this.language);
                }
            },
            __toggleLanguage(){
                if (this.language === 'zh-cn'){
                    localStorage.setItem('language', this.language);
                    this.language = 'en-us';
                    this.$store.commit('initLanguage', this.language);
                } else {
                    localStorage.setItem('language', this.language);
                    this.language = 'zh-cn';
                    this.$store.commit('initLanguage', this.language);
                }
                this.navDefaultActive();
                this.$emit('actions', this.language);
                // localStorage.removeItem('navRouter');
                this.$router.push('/');
            },
            onLogos(){
                this.isActive = 0;
                localStorage.setItem('navRouter', 'index');
                this.$router.push('/');
            },
            onNavigation(data, i){
                console.log(data, i);
                this.isActive = i;
                localStorage.setItem('navRouter', data.name);
            },
            toggleShareBox(){
                this.shareBox = !this.shareBox;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue